import * as React from "react";

import { Breadcrumbs } from "@/components/Breadcrumbs";
import { useQaWorkerWarmup } from "@/modules/chat/hooks/useQaWorkerWarmup";
import { RecentQATable } from "./components/RecentQATable";

export const RecentQAView: React.FC = () => {
  useQaWorkerWarmup();

  return (
    <>
      <div className="mb-2 flex items-center justify-between">
        <h1 className="text-2xl font-bold">Recent Q&A Conversations</h1>
      </div>
      <Breadcrumbs items={[{ label: "Home", href: "/" }, { label: "Recent Q&A" }]} />
      <div className="mt-5">
        <RecentQATable />
      </div>
    </>
  );
};
